export default __webpack_public_path__ + "static/media/PMT-DAMS_Logo_Intro.216a86cb.mp4";